module.exports = __webpack_public_path__ + "static/headshot-f6370bcd8c4f79e7a55ac2d402987044.jpg";